import { ref } from "vue";
import { r as rtlPluginKey } from "../../../keys-DUCx0SNv.mjs";
const rtlPlugin = {
  install(app, options) {
    var _a, _b;
    const rtlDefault = false;
    const localeDefault = void 0;
    const rtlInitial = typeof (options == null ? void 0 : options.rtl) === "boolean" ? rtlDefault : ((_a = options == null ? void 0 : options.rtl) == null ? void 0 : _a.rtlInitial) ?? rtlDefault;
    const localeInitial = typeof (options == null ? void 0 : options.rtl) === "boolean" ? localeDefault : ((_b = options == null ? void 0 : options.rtl) == null ? void 0 : _b.localeInitial) ?? localeDefault;
    const isRtl = ref(rtlInitial);
    const locale = ref(localeInitial);
    app.provide(rtlPluginKey, { isRtl, locale });
  }
};
export {
  rtlPlugin
};
//# sourceMappingURL=index.mjs.map
